import styles from "@/styles/cards.module.scss";

const BasicCards = ({ data }) => {
  const backgroundColor =
    data.backgroundColor === "primary"
      ? "bg-onmoPrimary"
      : data.backgroundColor === "black"
      ? "bg-onmoBlack"
      : data.backgroundColor === "grey"
      ? "bg-onmoGrey"
      : "bg-onmoBeige";

  return (
    <section className={`${backgroundColor}`}>
      <div className="text-center max-w-1424 mx-auto py-7 md:py-20 px-7 md:px-32">
        <h1 className={styles.mainTitle}>{data.title}</h1>
        <h5 className={styles.mainSubTitle}>{data.subTitle}</h5>
        <div className="my-5 flex flex-col md:flex-row gap-7 md:gap-10 text-left justify-around">
          {data.cards.map((v, i) => (
            <div
              className={`py-5 flex flex-col ${styles.cardContainer}`}
              key={i}
            >
              <h5 className={styles.cardTitle}>{v.title}</h5>
              <p className={`grow ${styles.cardDescription}`}>
                {v.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BasicCards;
